<template>
    <div>
        <app-page-header
            title="Salas"
            icon="fa fa-graduation-cap"
            :breadcrumbs="[
                { href: '/', title: 'Painel' },
                { href: '', title: 'Salas' },
            ]"
        ></app-page-header>

        <app-datatable
            ref="dataTable"
            entity="classrooms"
            :allow-enable-multi="allows.enableMulti"
            :allow-disable-multi="allows.disableMulti"
            :allow-delete-multi="allows.deleteMulti"
            :statusFilterIndex="5"
            :options="{
                print: true,
                columnsToPrint: [1,2,3,4],
                ajax: {
                    url: '/web/classrooms',
                },
                columns: columns,
            }"
            :actions="{
                qrcode: {
                    allow: allows.qrcode,
                    url: '/students/print_qrcode?classroom_id=*',
                },
                pass: {
                    allow: allows.pass,
                    url: '/students/print_password?classroom_id=*',
                },
                student: {
                    allow: allows.student,
                    url: '/students?classroom_id=*',
                },
                create: {
                    allow: allows.create,
                    url: '/classrooms/create',
                },
                edit: {
                    allow: allows.edit,
                    url: '/classrooms/*/edit',
                },
                settings: {
                    allow: allows.settings,
                    url: '/classrooms/*/settings'
                },
                delete: {
                    allow: allows.delete,
                    url: '*',
                },
            }"
        ></app-datatable>
    </div>
</template>

<script>
    import PageHeader from '../PageHeaderComponent';
	import DataTable from '../DataTableComponent';

    export default {
        components: {
            'app-page-header': PageHeader,
            'app-datatable': DataTable,
        },
        props: {
            allows: Object,
            columns: Array,
        }
    }
</script>